// extracted by mini-css-extract-plugin
export default {"box":"styles_box__2a9eH","root":"styles_root__GeEPV","checkbox":"styles_checkbox__Rlaxm"};